import {
  Component, OnInit,
  ViewChild, ViewContainerRef,
  Injector, Input
} from '@angular/core';
import {ExgWidgetService} from '../exg-widget.service';


@Component({
  selector: 'exg-widget',
  templateUrl: './exg-widget.component.html',
})
export class ExgWidgetComponent implements OnInit {

  @ViewChild('vc', {read: ViewContainerRef}) entry!: ViewContainerRef;
  private componentinstance: any;

  @Input()
  get name(): string {
    return this._name;
  }

  set name(name: string) {
    if (this.name !== name) {
      this._name = name;
      this.setComponent();
    }
  }

  private _name = '';

  @Input()
  get data(): any {
    return this._data;
  }

  set data(value: any) {
    this._data = value;
    if (this.componentinstance) {
      this.componentinstance[`data`] = this._data;
    }
  }

  private _data = {};

  constructor(private widgets: ExgWidgetService, private injector: Injector) {
  }

  ngOnInit(): void {
    this.setComponent();
  }

  private setComponent(): void {
    if (this._name.length > 0) {
      setTimeout(() => {
        this.entry.clear();
        this.componentinstance = this.entry.createComponent(this.widgets.GetFactory(this._name), undefined, this.injector).instance;
        this.componentinstance[`data`] = this._data;
      }, 10);
    }
  }
}
